import { isEqual } from "lodash";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaeButton from "../common_widgets/button";
import MdaeRadioGroup from "../common_widgets/radio-group";
import { GET_CASE_FIELDS_TAB_REFERENCE_DATA } from "./services/get-case-fields-tab-reference-data";
import { SET_SELECTED_AUDIT_ID } from "./reducers/case-fields-reducer";
import { callOperation } from "async-ops";
import { GET_REPORT_PACKAGE_ID_BY_NAME } from "./services/get-report-package-id-by-name";
import { HIDE_LOADER, SHOW_LOADER } from "../mdae-common-reducer";
import "./index.scss";
import { getUserPermissionObject } from "../user-permissions-helper";
import { INSERT_AUDIT_REPORT_LOG } from "../../pages/external-audit/audit-list/services/insert-audit-report-log";
const LinkedAuditItems: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const caseFieldsTabReferenceData = useSelector(
    (state) => state["caseFieldsReducer"].caseFieldsTabReferenceData,
    isEqual
  );
  const currentEaAuditId = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData?.eaAuditId
  );
  const eaCaseLinkedAuditsData = useSelector((state) =>
    state[
      "caseFieldsReducer"
    ].caseFieldsTabReferenceData?.eaCaseLinkedAuditsData.filter(
      (x) => x.linkedAuditId !== currentEaAuditId
    )
  );
  const selectedAuditId = useSelector(
    (state) => state["caseFieldsReducer"].selectedAuditId,
    isEqual
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );
  const selectedAuditData = useSelector((state) =>
    state[
      "caseFieldsReducer"
    ]?.caseFieldsTabReferenceData?.eaCaseLinkedAuditsData?.find(
      (x) => x.linkedAuditId === selectedAuditId
    )
  );

  
  const  writeAuditReportLog=(reportParams, reportUrl,t) =>{
  dispatch({ type: SHOW_LOADER });
   callOperation(INSERT_AUDIT_REPORT_LOG, reportParams).then(
    (response) => {
      dispatch({ type: HIDE_LOADER });
      if (response !== null && response.auditReportLogId > 0) {
        t.location = reportUrl + "?reportToken=" + response.uniqueGuidId + "&reportLogId=" + response.auditReportLogId;
      }
      else {
        dispatch({ type: HIDE_LOADER });
        return false;
      }
    }
  ).catch(() =>{
    dispatch({ type: HIDE_LOADER });
    return false;
  });
}
  const hasInternalAuditViewAccess = useMemo(() => {
    const uMenu = $.grep(currentUser?.userPermissions?.userMenu, function(
      e: any
    ) {
      return e.parentName === "Audit";
    });
    const allAuditList = uMenu?.filter(
      (x) => x.menuName?.toLowerCase() === "all audits"
    );
    return allAuditList.length;
  }, [currentUser]);

  return (
    <div>
      {eaCaseLinkedAuditsData?.length > 0 && (
        <div className="row remove-margin">
          <div className="col-xs-6">
            <div
              className="application-section-primary-color"
              style={{ fontSize: 20, marginTop: 7 }}
            >
              View Only
            </div>
          </div>
          <div className="col-xs-3">
            <div
              style={{ marginTop: 10, display: "flex", alignItems: "center" }}
            >
              {!hasInternalAuditViewAccess && (
                <span
                  className="fa fa-warning warning-icon-styles"
                  title="Audits linked to this audit group require additional privilages for viewing. Contact your manager for additional information."
                ></span>
              )}

              <div>Linked Audit ID:</div>
              <MdaeRadioGroup
                id="pnlAttachedAUditIds"
                layout="horizontal"
                style={{ marginLeft: 5 }}
                items={eaCaseLinkedAuditsData}
                valueExpr={"linkedAuditId"}
                itemRender={(linkedAudit) => {
                  return (
                    <>
                      {hasInternalAuditViewAccess && (
                        <a
                          href={
                            (linkedAudit.isExternalAudit
                              ? "/externalaudit/audit?auditId="
                              : "/audit/index/?auditId=") +
                            linkedAudit?.linkedAuditId
                          }
                          target="_blank"
                        >
                          {linkedAudit?.linkedAuditId}
                        </a>
                      )}
                      {!hasInternalAuditViewAccess && (
                        <span>{linkedAudit?.linkedAuditId}</span>
                      )}
                    </>
                  );
                }}
                mdaeDataUpdaterConfig={[
                  {
                    actionType: SET_SELECTED_AUDIT_ID,
                    reducerName: "caseFieldsReducer",
                    widgetOptionBindings: {
                      value: "selectedAuditId",
                    },
                  },
                  {
                    actionType: GET_CASE_FIELDS_TAB_REFERENCE_DATA,
                    reducerName: "caseFieldsReducer",
                    widgetOptionBindings: {
                      value: "selectedAuditId",
                    },
                  },
                ]}
              />
            </div>
          </div>
          <div className="col-xs-3 text-right">
            {selectedAuditData.isExternalAudit == false && (
              <MdaeButton
                id="btnCaseDetailReport"
                style={{ marginBottom: 5 }}
                role="secondary"
                onClick={() => {
                  let reportObject = {
                    reportName: "Audit Case Detail",
                    reportPackageType: "Report",
                    reportPackageId: "",
                  };
                  dispatch({ type: SHOW_LOADER });
                  callOperation(
                    GET_REPORT_PACKAGE_ID_BY_NAME,
                    reportObject.reportName
                  ).then((response) => {
                    dispatch({ type: HIDE_LOADER });
                    reportObject.reportPackageId = response;
                    var t = window.open("");
                    var pACDHidePoints = 0;
                    var pACDHideFinancial = 0;
                    var pACDHideHCC = 0;
                    var pACDHideFindings = 0;
                    var pPB = 1;
                    var pACDHideAuditorName = 0;
                    var pIncludeCaseDocuments = 0;
                    var reportUrl = "/Analyzer/ReportPreview";
                    var auditID = selectedAuditData?.linkedAuditId;
                    var auditOrgFieldId = "";
                    var entityName = "";
                    var auditIds = selectedAuditData?.linkedAuditId;
                    var auditCaseIds = selectedAuditData?.linkedAuditCaseId;
                    var reportParams = {};
                    reportParams = {
                      ReportPackageId: reportObject.reportPackageId,
                      AuditId: auditID,
                      AuditIdList: auditIds,
                      AcdHidePoints: pACDHidePoints,
                      HideFinancial: pACDHideFinancial,
                      HideHCC: pACDHideHCC,
                      HideFindings: pACDHideFindings,
                      AuditCaseIds: auditCaseIds,
                      AuditOrgFieldId: isNaN(parseInt(auditOrgFieldId))
                        ? 0
                        : parseInt(auditOrgFieldId),
                      EntityName: entityName,
                      PB: pPB,
                      AcdHideAuditorName: pACDHideAuditorName,
                      pIncludeCaseDocuments: pIncludeCaseDocuments,
                    };
                    writeAuditReportLog(reportParams, reportUrl, t);
                  });
                }}
              >
                Case Detail Report
              </MdaeButton>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
export default LinkedAuditItems;
